var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"teaching-supply-elective"},[_c('PlatDataGridSite',{attrs:{"grid-id":"PeTchElectiveSupply","extra-params":_vm.extraParams,"show-label":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }